export default "__VITE_PUBLIC_ASSET__a9425f49__"